import { useStore } from 'effector-react';
import Scrollbars from 'react-custom-scrollbars';
import { MAX_CATEGORIES } from '@constants';
import { $categoryList } from '@stores/dataStores';
import { showConfirmModal } from '@components/ConfirmModal';
import addCategory from '@modules/category/actions/addCategory';
import { showScenesCopyModal } from '../../ScenesCopyModal';
import { Item } from './Item';
import { MoreMenu } from '../MoreMenu';

export function MCategoryList() {
  const list = useStore($categoryList);
  const handleAddCategory = async () => {
    if (list.length >= MAX_CATEGORIES) {
      await showConfirmModal({
        title: '添加失败',
        buttonText: '我知道了',
        content: (
          <>
            <div>{`每个作品最多支持添加${MAX_CATEGORIES}个一级分组`}</div>
            <div>添加过多分组将影响作品打开速度，甚至打开失效</div>
          </>
        ),
      });
    } else {
      addCategory();
    }
  };

  return (
    <div className="grid select-none grid-rows-[40px_1fr] py-10">
      <div className="flex items-center pl-10 pr-30">
        场景管理
        <MoreMenu
          className="ml-auto"
          items={['创建一级分组', '跨作品复制'] as const}
          onSelect={(val) => {
            if (val === '创建一级分组') {
              handleAddCategory();
            } else if (val === '跨作品复制') {
              showScenesCopyModal({ level: '作品' });
            }
          }}
        />
      </div>
      <Scrollbars>
        <div className="relative pr-20">
          {list.map((x) => (
            <Item id={x} key={x} />
          ))}
        </div>
      </Scrollbars>
    </div>
  );
}

export default MCategoryList;
